"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ImageWrapper = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    height: ", ";\n    width: ", ";\n    background-image: ", ";\n    background-position: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n    cursor: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var GridStripped = function GridStripped(_ref) {
  var backgroundImage = _ref.backgroundImage,
      height = _ref.height,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["backgroundImage", "height"]);
  return /*#__PURE__*/_react["default"].createElement(_Grid["default"], props);
};

var ImageWrapper = (0, _styledComponents["default"])(GridStripped)(_templateObject(), function (props) {
  return props.height ? "".concat(props.height, "px") : '100%';
}, function (props) {
  return props.width ? "".concat(props.width, "px") : 'auto';
}, function (props) {
  return "url(".concat(props.backgroundImage, ")");
}, function (props) {
  return props.onClick ? 'pointer' : 'auto';
});
exports.ImageWrapper = ImageWrapper;
var _default = {
  ImageWrapper: ImageWrapper
};
exports["default"] = _default;